import { navigateToLogin } from "../../../../history";
import { api, notification } from "../../../../services";

function getError(option, xhr) {
  const msg = `Cannot post ${option.action} ${xhr.status}'`;
  const err: any = new Error(msg);
  err.status = xhr.status;
  err.method = "post";
  err.url = option.action;
  return err;
}

function getBody(xhr) {
  const text = xhr.responseText || xhr.response;
  if (!text) {
    return text;
  }

  try {
    return JSON.parse(text);
  } catch (e) {
    return text;
  }
}

// eslint-disable-next-line complexity,max-lines-per-function
export default function upload(isCompressed, option) {
  const xhr = new XMLHttpRequest();

  if (option.onProgress && xhr.upload) {
    xhr.upload.onprogress = function progress(e: any) {
      if (e.total > 0) {
        e.percent = (e.loaded / e.total) * 100;
      }
      option.onProgress(e);
    };
  }

  const formData = new FormData();

  if (option.data) {
    Object.keys(option.data).forEach(key => {
      formData.append(key, option.data[key]);
    });
  }

  xhr.onerror = function error(e) {
    option.onError(e);

    if (xhr.status === 401) {
      notification.showError(
        "Molimo, prijavite se za nastavak"
      );
      navigateToLogin();
    }
  };

  xhr.onload = function onload() {
    // allow success when 2xx status
    // see https://github.com/react-component/upload/issues/34
    if (xhr.status < 200 || xhr.status >= 300) {
      const body = getBody(xhr);

      if (body && body.code) {
        api.showErrorByCode(body.code);
      }

      return option.onError(getError(option, xhr), body);
    }

    return option.onSuccess(getBody(xhr), xhr);
  };

  xhr.open("post", option.action, true);

  const headers = option.headers || {};

  // when set headers['X-Requested-With'] = null , can close default XHR header
  // see https://github.com/react-component/upload/issues/33
  if (headers["X-Requested-With"] !== null) {
    xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest");
  }

  Object.keys(headers).forEach(header => {
    if (headers[header] !== null) {
      xhr.setRequestHeader(header, headers[header]);
    }
  });

  if (isCompressed) {
    formData.append(option.filename, option.file);
    xhr.send(formData);
  } else {
    formData.append(option.filename, option.file);
    xhr.send(formData);
  }

  return {
    abort() {
      xhr.abort();
    }
  };
}



// WEBPACK FOOTER //
// ./src/components/FormControls/PhotoUploader/compressImageRequest/compressImageRequest.ts